import { render, staticRenderFns } from "./PanelCommon.vue?vue&type=template&id=38bfbd8a&scoped=true&"
import script from "./PanelCommon.vue?vue&type=script&lang=js&"
export * from "./PanelCommon.vue?vue&type=script&lang=js&"
import style0 from "./PanelCommon.vue?vue&type=style&index=0&id=38bfbd8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfbd8a",
  null
  
)

export default component.exports